<template>
    <div :class="container">

    <div class="row pb-2" v-if="!headless">
        <div class="col">
          <h5>
            <span v-if="user.account=='Admin'">All Transactions</span>
            <span v-else>Transactions</span>
          </h5>
        </div>
    </div>

<div :class="card">
<div :class="cardBody">

      <p v-if="transactions.length == 0" :class="`text-center ${marginBottom}`">No transactions</p>

        <table v-else class="table">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="90%">Transaction</th>
                  <th class="first-right pr-3" width="10%"></th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(transaction, index) in transactions" :key="index.id">
              
    <td class="pl-3">
        <div v-if="transaction.project_id">
          <a class="transaction" :href="'/projects/view/'+transaction.project_id+'/0'">
          <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i>
          {{transaction.type.name}}<span v-if="transaction.fee_percent"> {{transaction.fee_percent}}%</span></a></div>
        <div v-else>{{transaction.type.name}} <span v-if="transaction.fee_percent">{{transaction.fee_percent}}%</span></div>
        <div :class="transaction.type.action">{{formattedPrice(transaction.amount)}}</div>
        <div class="project_list_date"><small><timeago
                  :datetime="transaction.created_at"
                  :auto-update="60"
                  :title="formatDate(transaction.created_at)"></timeago></small></div>
      </td>
      <td class="font-weight-bold pl-0"></td>

            </tr>
          </tbody>
        </table>

    </div>
</div>

  </div>
</template> 

<script>
import moment from 'moment'

export default {

  props: ['user','headless'],

  data() {
    return {
      transactions: [],
      loading: false,
      card: 'card',
      cardBody: 'card-body pb-3',
      container: 'container pb-4 mb-4',
      marginBottom: 'mb-0'
    };
  },

  created() {
    this.setClasses();

    this.getTransactions();

    Echo.private("transactions_" + this.user.id)
      .listen("NewTransaction", (event) => {
        this.getTransactions();
      });

  },

  methods: {

    setClasses() {
      if (this.headless) {
        this.card = '';
        this.cardBody = '';
        this.container = 'pt-3 px-3 pb-1';
        this.marginBottom = '';
      }
    },

    getTransactions() {

      this.loading = true;

      axios.get('/transactions/get').
      then((response) => {
        this.transactions = response.data;
        this.loading = false;
      });
    },

    formatDate(date) {
      return moment(String(date)).format('D MMMM YYYY HH:mm:ss')
    },

  },
};
</script>

<style scoped>
a.transaction:hover {
  font-weight:500;
}

</style>